"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ViewsVisualization = void 0;
var KeenDataViz = require("keen-dataviz").default;
var Views = require("Analytics/Visualizations/Views/Views.html");
var RecentViews = require("./RecentViews/RecentViews");
var ViewsVisualization = (function () {
    function ViewsVisualization(createUi, make, $q, eventData, options) {
        var _this = this;
        var _a;
        var recentViews;
        this.renderChart = this.renderChart.bind(this);
        if (options == null) {
            options = {};
        }
        if ((_a = eventData.scope) === null || _a === void 0 ? void 0 : _a.projectId) {
            recentViews = make(RecentViews, {
                options: {
                    showProjectName: options.showProjectName,
                },
            });
        }
        this.ui = createUi(Views, {
            views: [],
            showProjectName: options.showProjectName,
            loaded: false,
            recentViews: recentViews,
            $onElementRendered: function (elem) {
                return eventData.getDailyViewCounts().then(function (results) {
                    var _a;
                    _this.ui.loaded = true;
                    if ((_a = results === null || results === void 0 ? void 0 : results.result) === null || _a === void 0 ? void 0 : _a.length) {
                        _this.renderChart(results, elem);
                    }
                });
            },
        });
    }
    ViewsVisualization.prototype.renderChart = function (data, elem) {
        var container = $(elem).find(".chart--project-views")[0];
        this.chart = new KeenDataViz({
            container: container,
            type: "bar",
            size: {
                height: 275,
            },
            grid: {
                x: {
                    show: true,
                },
            },
        })
            .data(data)
            .render();
    };
    return ViewsVisualization;
}());
exports.ViewsVisualization = ViewsVisualization;
